import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getTownhall, submitTownhall, approveTownhall, disapproveTownhall,
} from "../../utils/helper";
import Loader from "../../utils/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { alertError, alertSuccess } from "../../utils/alerts";

const INIT_ORG = {
    title: "",
    date: "",
    year: "",
    month: "",
    description: "",
    meeting_link: "",
    document: "",
    organization: "",
    status: "",
    attendees: [],
}

export default function ViewLearning() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [townhall, setTownhall] = useState(INIT_ORG);
    const [approveComment, setApproveComment] = useState("");
    const [disapproveComment, setDisapproveComment] = useState("");
    
    useEffect(() => {
        if(id){
            setLoading(true);
            getTownhall(id)
            .then((res) => { 
                if(res.data.success){
                    setTownhall(res.data.data);  
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
        }
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        submitTownhall(id)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                window.location.reload();
            })
            .catch((err) => {
                alertError(err.response.data.error);
                setLoading(false);
            });
    };

    const handleChangeApprove = (e) => {
        e.persist();
        setApproveComment(e.target.value);
    };

    const handleChangeDisapprove = (e) => {
        e.persist();
        setDisapproveComment(e.target.value);
    };

    const handleApprove = async (e) => {
        e.preventDefault();
        const data = { comment: approveComment, id };
        setLoading(true);
        approveTownhall(data, id)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                window.location.reload();
            })
            .catch((err) => {
                alertError(err.response.data.error);
                setLoading(false);
            });
    };

    const handleDisapprove = async (e) => {
        e.preventDefault();
        const data = { comment: disapproveComment, id };
        setLoading(true);
        disapproveTownhall(data, id)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                window.location.reload();
            })
            .catch((err) => {
                alertError(err.response.data.error);
                setLoading(false);
            });
    };

    const isCanSubmit = townhall && townhall.status ? (townhall.status === "draft" || townhall.status === "declined") : false;

    return (
        <>
            <h1 className="dash-title"><Link to="/outsourcing/learning" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row">
                <div className="col-md-12 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Learning and Development 
                            </h3>
                            {!loading ?  <>
                                <ul className="personal-info">
                                    <li>
                                        <div className="title">Organization:</div>
                                        <div className="text"><span>{townhall.organization?.name && townhall.organization?.name} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Title:</div>
                                        <div className="text">{townhall?.title && townhall?.title}</div>
                                    </li>
                                    <li>
                                        <div className="title">Description:</div>
                                        <div className="text">{townhall?.description && townhall?.description}</div>
                                    </li>
                                    <li>
                                        <div className="title">Year:</div>
                                        <div className="text"><span>{townhall.year && townhall.year} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Month:</div>
                                        <div className="text"><span>{townhall.month && townhall.month} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Date of Meeting:</div>
                                        <div className="text"><span>{townhall.date && townhall.date} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Time of Meeting:</div>
                                        <div className="text"><span>{townhall.time && townhall.time} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Meeting Link:</div>
                                        <div className="text"><a href="#/" className="font-weight-bold">{townhall.meeting_link && townhall.meeting_link} </a></div>
                                    </li>
                                </ul>

                                {(isCanSubmit) ? (
                                <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                                    <div className="card-body">
                                        <div className="col-md-12 col-sm-12 text-center">
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary" 
                                                disabled={loading}
                                                onClick={handleSubmit} 
                                            >
                                                SUBMIT TOWNHALL MEETING
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                ) : null }
                                
                                {(townhall.status === "submitted") ? (
                                    <div className="card-body mt-4" style={{borderTop: '1px solid #ccc'}}>
                                        <div className="col-md-12 col-sm-12 text-center">
                                            <div className="btn-group">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-success" 
                                                    disabled={loading}
                                                    data-toggle="modal" data-target="#approve"
                                                    style={{width: 180}}
                                                >
                                                    APPROVE MEETING
                                                </button>
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-danger" 
                                                    disabled={loading}
                                                    data-toggle="modal" data-target="#decline"
                                                    style={{width: 180}}
                                                >
                                                    DISAPPROVE MEETING
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null }

                            </>

                            : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>


            {(townhall && townhall.attendees.length > 0) ? 
            <div className="row">
                <div className="col-md-12 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Attendees
                            </h3>
                            
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>SN</th><th>Name</th><th>Actions</th></tr></thead>
                                    <tbody>
                                        {/* {jobroles && jobroles.map((role,i ) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{role.name && role.name}</td>
                                                <td>
                                                    <button 
                                                        // onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                        className='btn btn-edit mr-2'
                                                        // disabled
                                                    >
                                                        Edit
                                                    </button>
                                                    <button 
                                                        onClick={() => handleDeleteJob(role._id)} 
                                                        className='btn btn-delete'
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))} */}
                                    </tbody>
                                </table>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            : null }


            <div id="decline" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">DISAPPROVE TOWNHALL MEETING</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="disapproveComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChangeDisapprove} defaultValue={disapproveComment || ""}>    
                                    </textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleDisapprove} 
                                        >
                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : "DISAPPROVE MEETING"} 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="approve" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">APPROVE TOWNHALL MEETING</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="approveComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChangeApprove} defaultValue={approveComment || ""} >    
                                    </textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleApprove} 
                                    >
                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : "APPROVE MEETING"} 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            
        </>
    );
}
